import Navbar from '../Navbar'

const Header = () => (
  <>
    <Navbar />
  </>
)

export default Header
